module.exports = __webpack_public_path__ + "./images/2b87c1e5c4a98fd6e644760fc9b99d8e.webp";